import React, { useEffect} from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import { connect} from 'react-redux';
import { Spinner, Alert } from 'react-bootstrap';
import './App.css';
import { PrivateRoute } from './components/private-routes/PrivateRoute';
import Header from './components/shared/header/Header';
import Footer from './components/shared/footer/Footer';
import Nav from './components/shared/nav/Nav';
import ExamDetails from './components/exam-details/ExamDetails';
import InstitutionDetails from './components/institution-details/InstitutionDetails';
import PersonalInformation from './components/personal-information/PersonalInformation';
import Welcome from './components/welcome/Welcome';
import Review from './components/review-submit/Review';
import Confirmation from './components/submit-confirmation/Confirmation';
import {SignOut} from './components/sign-out/SignOut';
import  {UserManager, WebStorageStateStore} from 'oidc-client';
import { AuthProvider } from 'oidc-react';
import TermsAndConditions from './components/Terms/Terms';
import TranscriptHistory from './components/transcript-history/Transcript-history';
import {
  toggleAlertShowStatus
} from './redux-building-blocks/actions';
import  AdyenPaymentForm  from './components/adyen-form/AdyenPaymentForm';



export const userManager = new UserManager({
  authority: process.env.REACT_APP_SAP_OIDC_AUTHORITY,
  client_id:process.env.REACT_APP_SAP_OIDC_CLIENT_ID,
  response_type: "code",
  redirect_uri: `${window.location.origin}${process.env.PUBLIC_URL}/transcript-history`,
  silent_redirect_uri: `${window.location.origin}${process.env.PUBLIC_URL}/transcript-history`,
  post_logout_redirect_uri: `${window.location.origin}${process.env.PUBLIC_URL}/`,
  userStore: new WebStorageStateStore({store:window.localStorage}),
  automaticSilentRenew: false,   
  scope:'openid profile email address roles orgs platformAccess uid',
  monitorSession: false,
  
})

// Handle silent renew errors - redirect to home on session expiry
userManager.events.addSilentRenewError((error) => {
  console.error('Silent renew error:', error);
  localStorage.clear();
  window.location.href = `${process.env.PUBLIC_URL}/`;
});

// Handle user sign-out
userManager.events.addUserSignedOut(() => {
  console.log('User signed out');
  localStorage.clear();
  window.location.href = `${process.env.PUBLIC_URL}/`;
});

// Handle access token expired
userManager.events.addAccessTokenExpired(() => {
  console.log('Access token expired');
  localStorage.clear();
  window.location.href = `${process.env.PUBLIC_URL}/`;
});


export const AppComp = (props) => {
  const handleAlerClose = () => {
    props.toggleAlertShowStatus({
        showAlert: false,
        alertVarient: '',
        alertMessage: ''
    })
  }

 // to implement auto close of alert message
   useEffect(() => {
      if(props.showAlert) {
        window.setTimeout(()=>{
          handleAlerClose();
        },5000)
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.showAlert]);

  return (
    
    <Router basename={process.env.PUBLIC_URL}>
      <div className="container-fluid m-0 p-0 d-flex flex-column flex-lg-row min-h-100">
        <Nav />
        <div className="d-flex flex-column col-lg-10 p-0 min-h-100 flex-grow-1">
          {props.isLoggedin === true && <Header />}
          <main role="main" style={{ pointerEvents: props.isShowLoader ? 'none' : 'auto' }} className="content d-flex flex-column w-100 p-3">
            {props.isShowLoader && 
              <Spinner animation="grow" size="xl" role="status" className="elem-to-center">
                <span className="sr-only">Loading...</span>
              </Spinner>}
            {props.showAlert && 
              <Alert variant={props.alertVarient} onClose={handleAlerClose} dismissible>
                {props.alertMessage}
              </Alert>
            }
            <Switch>
              <Route exact path="/">
                <Welcome  />
              </Route>
              <AuthProvider userManager={userManager}>
              <PrivateRoute path='/transcript-history' component={TranscriptHistory} value='History' />
              <PrivateRoute path='/personal-information' component={PersonalInformation} value='Personal' />
              <PrivateRoute path='/exam-details' component={ExamDetails}   value='Exam' />
              <PrivateRoute path='/institution-details' component={InstitutionDetails} value = 'Institution' />
              <PrivateRoute path='/review' component={Review} value='Review' />
              <PrivateRoute path='/acceptTerms' component={TermsAndConditions} value='Terms' />
              <PrivateRoute path='/adyenPayment' component={AdyenPaymentForm} value='AdyenForm' />
              <PrivateRoute path='/confirmation' component={Confirmation}  value='Confirmation'/>
              <PrivateRoute path='/sign-out' component={SignOut} value='SignOut' />
              </AuthProvider>
            </Switch>
          </main>
          <Footer />
        </div>
      </div>
    </Router>  
    
  );
}


const mapStateToProps = state => {
  return { 
    showAlert: state.commonData.showAlert,
    alertVarient: state.commonData.alertVarient,
    alertMessage: state.commonData.alertMessage,
    isShowLoader: state.commonData.isShowLoader,
    isLoggedin: state.currentUser.isUserLoggedIn
   };
};

const mapDispatchToProps = { 
  toggleAlertShowStatus
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AppComp)

